<!-- =========================================================================================
  File Name: ListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table ref="table"  :data="filteredStudentList" :max-items="itemsPerPage"  pagination
              search>
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ACTION - DROPDOWN -->

        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ students.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : students.length }} of {{ queriedStudents }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead" >
        <vs-th sort-key="name">Image</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th>{{ $t('student.table.users') }}</vs-th>
        <vs-th>{{ $t('student.table.program') }}</vs-th>
        <vs-th>{{ $t('student.table.status') }}</vs-th>
        <vs-th sort-key="popularity">Camera(s)</vs-th>
      </template>

      <template slot-scope="{data}" >
        <tbody >
        <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td class="img-container">
            <img v-if="tr.image" :src="img_cdn+tr.image" class="rounded-full coverimg shadow-md studentdot mr-2"/>
            <p v-else class="bg-primary studentdot text-white mr-2" :data-letterstudent="tr.fname[0].toUpperCase()"></p>
          </vs-td>
          <vs-td>
            <router-link :to="{ path: '/'+ $t('route.teacher_student_profile.title') +'/'+ tr.id}" class="text-inherit " >
            <p v-if="lng === 'dogs'" class="product-name font-medium truncate flex">{{tr.fname}}</p>
            <p v-else class="product-name font-medium truncate">{{tr.fname}} {{tr.middle_name}} {{tr.lname}}</p>
            </router-link>
            <span class="flex items-center" @click="MessagePopupAction(tr.id)">
                  <feather-icon icon="MessageCircleIcon"  svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Messages</span>
                </span>
          </vs-td>
          <vs-td>
                <div v-for="item in tr.users" :key="item.id">
                 <vs-chip >{{item.fname}} {{item.lname}}</vs-chip>
                </div>
              </vs-td>
                <vs-td>
                <vs-chip v-if="tr.program.color_code" class="product-order-status text-white" :style="{background: tr.program.color_code}">{{ tr.program.name | title }}</vs-chip>
                <vs-chip v-else class="product-order-status" >{{ tr.program.name | title }}</vs-chip>
              </vs-td>
                <vs-td>
                <vs-switch v-model="tr.status" disabled="true"></vs-switch>
              </vs-td>
          <vs-td>
            <vx-tooltip style="display: inline-block" v-for="item in tr.cameras" :key="item.id" :text="item.name"
                        position="top">
            <p :style="{background: item.color_code}"
            class="w-4 h-4 round" style="float: left"></p>
            </vx-tooltip>

          </vs-td>
            </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <div class="demo-alignment">
      <div class="fill-row-loading">
        <div
          :class="{ activeLoading: activeLoading }"
          :id="[`loading-sound`]"
          class="vs-con-loading__container loading-example"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import {
  GET_TEACHER_STUDENTS 
} from '@/graphql'

export default {
  components: {

    moment
  },
  data () {
    return {
      students: [],
      selected: [],
      itemsPerPage: 4,
      isMounted: false,
      meID: '',
      meRole: '',
      img_cdn:process.env.VUE_APP_AWS_s3Url+"/",
      lng:'',
      types: ['sound'],
      activeLoading: false,
      custom_search_filter: 'Search By Location',
      custom_search_filter_camera: 'Search By Camera'
    }
  },
  computed: {
    filteredStudentList () {
      const custom_search_filter_camera = this.custom_search_filter_camera
      const custom_search_filter = this.custom_search_filter
      return this.students.filter(function (student) {
        if (
          custom_search_filter_camera != 'Search By Camera' &&
          custom_search_filter == 'Search By Location'
        ) {
          for (let i = 0; i < student.cameras.length; i++) {
            if (student.cameras[i].name == custom_search_filter_camera) {
              return true
            }
          }
          return false
        }
        if (custom_search_filter == 'Search By Location') {
          return true
        }
        if (custom_search_filter !== 'Search By Location') {
          return student.location.name.match(custom_search_filter)
        }
        return true
      })
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },

    queriedItems () {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.products.length
    },

    locln () {
      return this.locations.length
    },
    queriedStudents () {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.students.length
    },
    select () {
      return this.selected.length
    }
  },
  methods: {
    MessagePopupAction (id) {
      this.$store.dispatch('setStudent', null)
      this.$store.dispatch('setStudent', id)
      this.$router.push('/alerts')
    },
    setSelected (value) {
      this.custom_search_filter = value
    },
    cameraSelected (value) {
      this.custom_search_filter_camera = value
    },
    get () {
      this.$apollo
        .mutate({
          mutation: GET_TEACHER_STUDENTS
        })
        .then((response) => {
          console.log(response)
          this.students = response.data.teacher_students
          this.activeLoading = false
          this.$vs.loading.close()
        })
        .catch((error) => {
          console.log(error)
          this.activeLoading = false
          this.$vs.loading.close()
        })
    }
  },
  created () {
    this.lng = process.env.VUE_APP_I18N_LOCALE
    this.get()
  },
  mounted () {
    this.isMounted = true
  },
  beforeCreate () {
    this.activeLoading = true
    this.$vs.loading({
      type: 'sound'
    })
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  [data-letterstudent]:before {
    content: attr(data-letterstudent);
  }

  .studentdot {
    display: inline-block;
    font-size: 35px;
    width: 50px;
    height: 50px;
    text-align: center;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: -10px;
    margin-bottom: 5px;
  }

  .user_add_btn {
    float: right;
    margin-top: -50px;
  }

  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px;
    }
  }

  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
    .product-img {
      height: 70px;
      border-radius: 50%;
    }
  }
}
</style>
